// extracted by mini-css-extract-plugin
export default {"desktop":"desktop_desktop__6n7iz","content":"desktop_content__9f122","logo":"desktop_logo__JX4-R"};